import Vue from 'vue'
import VueI18n from 'vue-i18n'
const merge = require('lodash/merge')

Vue.use(VueI18n)

function getMsgs(locales) {
    const messages = {}
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)

        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale] = locales(key)
        }
    })
    return messages
}

function loadLocaleMessages() {
    const mxsQueryEditorMsgs = getMsgs(require.context('mxs-query-editor/dist/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i))
    const appMsgs = getMsgs(require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i))
    return merge(appMsgs, mxsQueryEditorMsgs)

}
export default new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'en',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: loadLocaleMessages(),
})
